import {ProspectPool} from 'api';
import React from 'react';
import {Row} from 'react-table';

interface Props {
  row: Row<ProspectPool>;
}

const LatestLeadSource = ({row}: Props) => {
  const prospectPool = row.original;

  if (!prospectPool.user) {
    return <></>;
  }

  return (
    <div>
      {[prospectPool?.user?.lastName, prospectPool?.user?.firstName]
        .filter(Boolean)
        .join(' ')}
    </div>
  );
};

export default LatestLeadSource;
